const question = {
    rebuy: { point: [0], rejectedProfiles: ['D'] },
    advice: { point: [2] },
    arbitration: { point: [1] },
    waiting: { point: [4] },
};

export default question;
